import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, organization, nextOrganization }) =>
    present(
      repository
        .updateOrganization(planzone, organization, nextOrganization)
        .then((organization) => ({ organization, planzone }))
        .catch(() =>
          Promise.reject({ planzone, organization, nextOrganization }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
